import axios from 'axios'
import { Message } from 'element-ui'
// import store from '@/store/index'
import { getToken } from '@/utils/auth'
import router from '../router'
// 测试环境
//currentAddress
  let baseURL =  window.global_config.BASE_URL// 东乐 e 聘
//  let baseURL = "https://test.fjfs.fsoline.com:8888/"//富升
// let baseURL = "https://localhost:8081"
// 李义攀本地
// let baseURL = "http://121.79.146.54:8081"
// 本地环境
//  let baseURL = "http://127.0.0.1:8081"
// 研发环境 
// let baseURL = "http://123.56.120.104:8080"
// let baseURL = "http://localhost:8081"
// let baseURL = "http://172.20.10.13:8081"
// let baseURL = "http://development.leylh.com:8081"
 //let baseURL = "http://nxb4dw.natappfree.cc"
//正式环境
//  let baseURL = "https://server.ly.leylh.com";// 东乐 e 聘
// let baseURL = "https://fjfs.fsoline.com:8888/";//富升
//let baseURL ="http://192.168.1.5:8081"
// create an axios instance
const service = axios.create({
  baseURL: baseURL,//process.env.VUE_APP_BASE_API, // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 5000000 // request timeout
})
axios.defaults.baseURL = baseURL;
export {
  baseURL
}

// request interceptor
service.interceptors.request.use(config => {
    // do something before request is sent

    if (getToken()) {
      // let each request carry token
      // ['X-Token'] is a custom headers key
      // please modify it according to the actual situation
      // config.headers['token'] = getToken()
      config.headers = {
        // "Content-Type": "multipart/form-data",
        "Authorization": getToken()
      }
      return config
    }
    if (!config.headers.Authorization) {
      if(window.location.href.indexOf('xlp.leylh') >-1 || window.location.href.indexOf('xlptest.leylh') >-1){
        router.history.push('/xlpLogin');
       
      }else{
        router.history.push('/leyeLogin');
      }
      return config;
    }
    return config
  },
  error => {
    // do something with request error
    // console.log(error,'req error') // for debug
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(response => {
    const res = response.data
    // console.log(res,'+++++++++');
    // if the custom code is not 20000, it is judged as an error.
    // if (res.type !== 1) {
    //   Message({
    //     message: res.message || 'Error',
    //     type: 'error',
    //     duration: 5 * 1000
    //   })
    if(res.code == '401'){
      if(window.location.href.indexOf('xlp.leylh') >-1 || window.location.href.indexOf('xlptest.leylh') >-1){
        router.history.push('/xlpLogin');
       
      }else{
        router.history.push('/leyeLogin');
      }
      // router.history.push('/leyeLogin');
    }
    if (response.status == 200) {
      return res;
    } else {
      // 不为200就是失败
      // console.log(error,'res error')
      return Promise.reject(res);
    }

    //   // 50008: Illegal token; 50012: Other clients logged in; 50014: Token expired;
      // if (res.code === 50008 || res.code === 50012 || res.code === 50014) {
      //   // to re-login
      //   MessageBox.confirm('You have been logged out, you can cancel to stay on this page, or log in again', 'Confirm logout', {
      //     confirmButtonText: 'Re-Login',
      //     cancelButtonText: 'Cancel',
      //     type: 'warning'
      //   }).then(() => {
      //     store.dispatch('user/resetToken').then(() => {
      //       location.reload()
      //     })
      //   })
      // }

    // return res;
  },
  error => {
    // console.log('err' + error) // for debug
    Message({
      message: error.message,
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(error)
  }
)

export default service
